import JobCard from '@web/components/JobCard';
import React from 'react';
import {buildQuery} from '@web/lib/firestore.db';
import PropTypes from 'prop-types';
import useQueryFirestore from '@web/hooks/useQueryFirestore';
import {Button, List} from 'antd';
import SimplePager from '@web/components/SimplePager';
import {LinesContext, WindowContext} from '@web/hooks/context';

WorkflowJobsList.propTypes = {
  source: PropTypes.string.isRequired,
  onSelectItem: PropTypes.func,
  header: PropTypes.node,
}

function WorkflowJobsList(props) {
  const ctx = React.useContext(LinesContext);
  const [, width] = React.useContext(WindowContext);
  const [dataItems] = useQueryFirestore(
    buildQuery(
    [ctx.basePath, "jobs"],
    {"==": {"source": props.source}},
    {limit: 5},
  ));

  const pageSize = (width < 1900) ? 2 : 4;

  return <SimplePager
    pageSize={pageSize}
    dataSource={dataItems}
  >
    <List
      header={props.header || null}
      className="list-no-separator"
      renderItem={
        ([id, job, jobPath], index) => {
          return <List.Item key={id + index} className="list-item-no-divider">
            {id ?
              <JobCard
                job={job}
                path={jobPath}
                preview
                onSelect={props.onSelectItem}
              /> :
              <Button block size="large" shape="round">
                <span className="muted font-lg">Add a workflow to this collection</span>
              </Button>}
          </List.Item>
        }}
      locale={{
        emptyText: <span>Add a workflow to do things with new data in this collection</span>
      }}
    />
  </SimplePager>;
}

export default WorkflowJobsList;
